import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'lecturer';

const initialState = {
    data: {},
    change: {},
    registrationConsent: [],
    studentSatisfaction: [],
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setChange(state, action) {
            state.change = json.toJSON(action.payload);
        },
        setRegistrationConsent(state, action) {
            state.registrationConsent = json.toJSON(action.payload);
        },
        setStudentSatisfaction(state, action) {
            state.studentSatisfaction = json.toJSON(action.payload);
        },
    }
});

export const { setData, setChange, setRegistrationConsent, setStudentSatisfaction } = slice.actions;

export const selectData = state => json.fromJSON(state[name].data);
export const selectChange = state => json.fromJSON(state[name].change);
export const selectRegistrationConsent = state => json.fromJSON(state[name].registrationConsent);
export const selectStudentSatisfaction = state => json.fromJSON(state[name].studentSatisfaction);

const lecturerReducer = slice.reducer;
export default lecturerReducer;